import type { HTMLAttributes, ReactNode } from 'react';

/**
 * Card — the white rounded surface every other component sits on.
 *
 * Corpus: `CC:10` (white fill, 20px radius), `JC:62-75` (white card,
 * hairline border, 24px padding), `DB:1828-1835,2555` (the app's product
 * card — white, 20px, `0 1px 4px` shadow), `DB:657` (the 1px `#ececee`
 * edge). No one
 * file carries all five: the surface follows the app's product card and takes
 * its padding from the journey cards. Every value is a cited token already.
 *
 * A plain `div` and not a `section`: the surface is decoration, and only the
 * caller knows whether what sits on it is a landmark, a list or a figure. Every
 * other prop reaches the element, so a caller who knows can say so.
 */
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  readonly children: ReactNode;
}

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div {...rest} className={['rp-card', className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
